import React, { useState, useEffect, useRef } from "react";
import { CiSearch } from "react-icons/ci";
import { BsCheckLg } from "react-icons/bs";
import { FaSave } from "react-icons/fa";
import {
  Box,
  Divider,
  FormControl,
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
} from "@mui/material";
import { TbArrowBackUp } from "react-icons/tb";
import axios from "axios";
import { toast } from "react-toastify";
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { API_HOST } from "../api_utils";
import Loader from "../Shared_Components/Loader";
import { MdOutlineKeyboardBackspace } from "react-icons/md";

function LoanDetail(props) {
  const { userDataFromStorage, coloredTheme } = props;
  let navigate = useNavigate();

  // states for customer :
  const [customerRef, setCustomerRef] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showLoanCustomerDetail, setShowLoanCustomerDetail] = useState(false);
  const [customerLoanDetail, setCustomerLoanDetail] = useState(false);
  const [confirmDetail, setConfirmDetail] = useState(false);

  const [loanProductList, setLoanProductList] = useState([]);
  const [nickName, setNickName] = useState("");
  const [filterFrequency, setFilterFrequency] = useState("");
  const [productCode, setProductCode] = useState("");

  const singaporeTimezone = "Asia/Singapore";
  const currentDateInSingapore = new Date().toLocaleDateString("en-US", {
    timeZone: singaporeTimezone,
  });

  // add loan api payload (states):
  const [addLoanPayload, setAddLoanPayload] = useState({
    customer_ref: "",
    loan_product_ref: "",
    customer_stamp_duty: "",
    future_holidays: "",
    cash_disbursed_date: formatDate(currentDateInSingapore),
    amount_dispersed: "",
  });

  const [transactionDate, setTransactionDate] = useState(
    formatDate(currentDateInSingapore)
  );

  function formatDate(dateString) {
    const [month, day, year] = dateString.split("/");
    const formattedMonth = month.padStart(2, "0");
    const formattedDay = day.padStart(2, "0");
    return `${year}-${formattedMonth}-${formattedDay}`;
  }

  const [advancePayments, setAdvancePayments] = useState("");

  const [selectedCustomerData, setSelectedCustomerData] = useState({}); //it will consist the customer data related to the selected customer header  (single object)

  const [selectedCustomerHeaderData, setSelectedCustomerHeaderData] = useState(
    {}
  ); //  it will consist of the customerHeader that is being selected (single object)

  const [selectedLoanProductData, setSelectedLoanProductData] = useState({}); // it will store the selected loan product detail

  const [isAmountDispersed, setIsAmountDispersed] = useState(false); //if all other fields for loan entry are field (non-empt) then set it to true to show calculated amount dispersed

  const [addLoanSuccess, setAddLoanSuccess] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const getCustomerApiCall = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/customer/get_customer_head_relation?page=${currentPage}&pageSize=${pageSize}`;

    const queryParams = [];
    console.log("nickname:::::::", nickName);
    if (nickName) {
      queryParams.push(`nickname=${nickName}`);
    }

    if (queryParams.length > 0) {
      const queryString = queryParams.join("&");
      apiUrl += `&${queryString}`;
    }

    console.log("queryParams:::::", queryParams);
    console.log("apiUrl:::::", apiUrl);

    const { data } = await axios.get(apiUrl, config);
    if (data.message) {
      setLoading(false);
      toast.error(data.message);
    } else {
      setLoading(false);
      setCustomerRef(data);
    }
  };

  const getCustomerApiCallManager = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/customer/get_customer_head_relation_others?page=${currentPage}&pageSize=${pageSize}`;

    const queryParams = [];
    if (nickName) {
      queryParams.push(`nickname=${nickName}`);
    }

    if (queryParams.length > 0) {
      const queryString = queryParams.join("&");
      apiUrl += `&${queryString}`;
    }

    const { data } = await axios.get(apiUrl, config);
    if (data.message) {
      setLoading(false);
      toast.error(data.message);
    } else {
      setLoading(false);
      setCustomerRef(data);
    }
  };

  // get Loan Product list :
  const getLoanProductListApiCall = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    let apiUrl = `${API_HOST}/api/loanproducts/get_loan_products`;

    // Construct the query parameters based on available values
    const queryParams = [];
    if (productCode) {
      queryParams.push(`product_code=${productCode}`);
    }
    if (filterFrequency) {
      queryParams.push(`frequency=${filterFrequency}`);
    }

    if (queryParams.length > 0) {
      apiUrl += `?${queryParams.join("&")}`;
    }

    const { data } = await axios.get(apiUrl, config);
    if (data.message) {
      setLoading(false);
      toast.error(data.message);
    } else {
      setLoading(false);
      setLoanProductList(data);
    }
  };

  useEffect(() => {
    getLoanProductListApiCall();
    if (userDataFromStorage.user_role === "admin") {
      getCustomerApiCall();
    } else {
      getCustomerApiCallManager();
    }
  }, [currentPage]);

  useEffect(() => {
    if (
      addLoanPayload.cash_disbursed_date &&
      addLoanPayload.customer_stamp_duty &&
      addLoanPayload.future_holidays &&
      addLoanPayload.initial_days_deducted
    ) {
      setIsAmountDispersed(true);
    } else {
      setIsAmountDispersed(false);
    }
  }, [
    addLoanPayload.cash_disbursed_date &&
      addLoanPayload.customer_stamp_duty &&
      addLoanPayload.future_holidays &&
      addLoanPayload.initial_days_deducted,
  ]);

  useEffect(() => {
    if (
      addLoanPayload.cash_disbursed_date &&
      addLoanPayload.customer_stamp_duty &&
      addLoanPayload.future_holidays &&
      addLoanPayload.initial_days_deducted
    ) {
      const calculatedAmountDispersed =
        selectedLoanProductData?.amount -
        parseInt(addLoanPayload.customer_stamp_duty) -
        selectedLoanProductData?.collection_amount *
          (parseInt(addLoanPayload.future_holidays) +
            parseInt(addLoanPayload.initial_days_deducted));
      console.log("calculatedAmountDispersed", calculatedAmountDispersed);
      setAddLoanPayload((prevState) => ({
        ...prevState,
        amount_dispersed: parseInt(calculatedAmountDispersed),
      }));
    }
  }, [
    addLoanPayload.cash_disbursed_date &&
      addLoanPayload.customer_stamp_duty &&
      addLoanPayload.future_holidays &&
      addLoanPayload.initial_days_deducted,
  ]);

  const addLoanHandler = async () => {
    setLoading(true);
    if (
      addLoanPayload.cash_disbursed_date &&
      addLoanPayload.customer_stamp_duty &&
      addLoanPayload.future_holidays &&
      addLoanPayload.amount_dispersed
    ) {
      if (confirmDetail) {
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userDataFromStorage?.token}`,
          },
        };

        console.log("selectedCustomerData::::::::::", selectedCustomerData);

        const newPayload = {
          customer_ref: selectedCustomerData.id_number,
          loan_product_ref: selectedLoanProductData.id_number,
          amount_dispersed: addLoanPayload.amount_dispersed,
          customer_stamp_duty: parseInt(addLoanPayload.customer_stamp_duty),
          future_holidays: parseInt(addLoanPayload.future_holidays),
          cash_disbursed_date: addLoanPayload.cash_disbursed_date,
          initial_days_deducted: addLoanPayload.initial_days_deducted,
        };

        const data = await axios.post(
          `${API_HOST}/api/loan_header/add_loan_details`,
          newPayload,
          config
        );

        if (data.status === 200) {
          setLoading(false);
          setAddLoanSuccess(true);
          toast.success(data.data.message);
        } else {
          setLoading(false);
          toast.error(data.data.message);
        }
      } else {
        setLoading(false);
        toast.warn("Loan Can't Be Added Without Accepting The Loan Details");
      }
    } else {
      setLoading(false);
      toast.error("please provide all the fields !!!");
    }
  };

  // close customerLoanDetail:
  useEffect(() => {
    if (addLoanSuccess) {
      navigate("/loans");
    }
  }, [addLoanSuccess]);

  return (
    <div
      className={
        userDataFromStorage.user_role === "admin"
          ? "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-sky-50  overflow-hidden"
          : "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[4%] mt-[20%] bg-sky-50 overflow-hidden"
      }>
      <div className="flex justify-start items-center space-x-4">
        <p
          onClick={() => navigate("/loans")}
          className="text-[2.3rem] text-gray-700 hover:text-gray-300 transition duration-[0.5s]">
          <MdOutlineKeyboardBackspace />
        </p>
        <p className="text-gray-700  w-[10rem] text-[1.8rem] tracking-wider ">
          Loan Detail
        </p>
      </div>

      {loading ? (
        <Loader />
      ) : !showLoanCustomerDetail ? (
        <div className="w-[100%]">
          <div className="bg-white md:text-[0.75rem] pb-[1rem] lg:text-[1rem] ">
            <p
              style={{ backgroundColor: coloredTheme }}
              className=" text-white px-[0.5rem] py-[1rem] mt-6">
              Search for the Customer who is taking Loan by Nickname and then
              Select them.
            </p>

            <div className="md:px-[0.5rem] px-[0.7rem] py-[0.5rem] mt-[1rem] flex justify-start items-center">
              <label htmlFor="customerNickname" className="w-[30%]">
                Customer Nickname
              </label>

              <input
                value={nickName}
                onChange={(e) => setNickName(e.target.value)}
                type="text"
                id="customerNickname"
                className="border outline-none p-[0.5rem] border-gray-600 flex-1 rounded-lg"
                placeholder="Enter Customer Nickname"
              />
            </div>

            <div className="flex justify-start items-center px-[0.5rem]">
              <button
                onClick={() => {
                  if (userDataFromStorage.user_role === "admin") {
                    getCustomerApiCall();
                  } else {
                    getCustomerApiCallManager();
                  }
                }}
                style={{ backgroundColor: coloredTheme }}
                className="flex justify-start items-center space-x-2 text-white px-[1rem] py-[0.5rem] rounded  transition duration-[0.6s] hover:shadow-2xl hover:shadow-black mt-[1rem]">
                <CiSearch />
                <span>Search for Customer</span>
              </button>
            </div>
          </div>

          {/* table for customer list */}
          <div className="overflow-scroll  mt-[1rem] w-[100%]">
            <table className="md:w-[100%] xl:w-[100%] w-[180%] ">
              <thead className="h-[6vh]">
                <tr
                  style={{ backgroundColor: coloredTheme }}
                  className="border border-gray-700  text-white tracking-wider">
                  <th
                    className={
                      customerRef.length
                        ? "text-center border-b border-r    border-gray-700 px-[0.2rem] w-1/4"
                        : "text-center px-[0.2rem] w-1/4 "
                    }>
                    {" "}
                    Nickname
                  </th>
                  <th
                    className={
                      customerRef.length
                        ? "text-center  px-[0.2rem] border-b border-r   border-gray-700 w-1/4"
                        : "text-center px-[0.2rem] w-1/4"
                    }>
                    Customer Name
                  </th>
                  <th
                    className={
                      customerRef.length
                        ? "text-center border-b border-r   border-gray-700 px-[0.2rem] w-1/4"
                        : "text-center px-[0.2rem] w-1/4"
                    }>
                    Phone Number's
                  </th>
                  <th
                    className={
                      customerRef.length
                        ? "text-center  px-[0.2rem] border-b border-r   border-gray-700 w-1/4"
                        : "text-center px-[0.2rem] w-1/4"
                    }>
                    Agent Name
                  </th>
                  <th
                    className={
                      customerRef.length
                        ? "text-center border-b  border-gray-700 px-[0.2rem] w-1/4"
                        : "text-center px-[0.2rem] w-1/4"
                    }>
                    Action{" "}
                  </th>
                </tr>
              </thead>
              <tbody>
                {customerRef.length
                  ? customerRef.map((x, index) => (
                      <tr
                        className={
                          index % 2 === 0
                            ? "bg-white border border-gray-700 "
                            : "border border-gray-700 bg-sky-100"
                        }
                        key={index}>
                        <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">
                          {" "}
                          {x.nickname}
                        </td>
                        <td className="text-center border-r border-gray-700 py-[0.3rem]  px-[0.2rem]">
                          {x.customer_name}
                        </td>
                        <td className="text-center border-r border-gray-700 py-[0.3rem] px-[0.2rem] ">
                          <span>{x.mobile_number}</span>
                          {x?.phone_2 ? (
                            <span className="block">{x.phone_2}</span>
                          ) : (
                            ""
                          )}
                          {x?.phone_3 ? (
                            <span className="block">{x.phone_3}</span>
                          ) : (
                            ""
                          )}
                          {x?.phone_4 ? (
                            <span className="block">{x.phone_4}</span>
                          ) : (
                            ""
                          )}
                        </td>
                        <td className="text-center border-r border-gray-700 py-[0.3rem]  px-[0.2rem]">
                          {x.agent_name}
                        </td>

                        <td className="px-[6rem]">
                          <button
                            onClick={() => {
                              setSelectedCustomerData(x);
                              setShowLoanCustomerDetail(true);
                            }}
                            style={{ backgroundColor: coloredTheme }}
                            className="flex justify-center items-center space-x-2  px-[1rem] py-[0.5rem] rounded change-bg text-white transition duration-[0.6s] hover:shadow-2xl hover:shadow-black">
                            <BsCheckLg />
                            <span>Select</span>
                          </button>
                          {/* manager/admin access to close a loan */}
                        </td>
                      </tr>
                    ))
                  : ""}
              </tbody>
            </table>
          </div>

          <div className="flex justify-end space-x-4 items-center mt-4  h-[50%]">
            <button
              className=" px-6 py-2 rounded-lg text-white bg-gray-400 hover:bg-gray-200 shadow-xl hover:text-gray-600 transition duration-[0.5s] tracking-wider"
              onClick={() => setCurrentPage(currentPage - 1)}
              disabled={currentPage === 1}>
              Prev
            </button>
            <button
              className=" px-6 py-2 rounded-lg text-white bg-gray-400 hover:bg-gray-200 shadow-xl hover:text-gray-600 transition duration-[0.5s] tracking-wider"
              onClick={() => setCurrentPage(currentPage + 1)}>
              Next
            </button>
          </div>
          {!isAmountDispersed ? (
            <div>
              <button
                style={{ backgroundColor: coloredTheme }}
                onClick={() => navigate("/loans")}
                className="flex justify-start items-center space-x-2  px-[1rem] py-[0.5rem] rounded text-white transition duration-[3s] hover:shadow-2xl hover:shadow-black mt-[1rem]">
                <TbArrowBackUp />
                <span>Cancel</span>
              </button>
            </div>
          ) : (
            ""
          )}
        </div>
      ) : (
        <div className="w-[100%]">
          <div className="bg-white md:text-[0.75rem] lg:text-[1rem]">
            <p
              style={{ backgroundColor: coloredTheme }}
              className=" text-white px-[0.5rem] py-[1rem] mt-6">
              The Customer Detail's Taking loan Are as follows :{" "}
            </p>
            <div className="md:px-[0.5rem] px-[0.7rem]">
              <div className="md:flex justify-start items-center border-b md:h-[4rem] mt-2 md:mt-0">
                <div
                  style={{ borderRight: `2rem solid ${coloredTheme}` }}
                  className="flex justify-between md:w-[50%] items-center  md:border-r-[2rem] h-[100%]  ">
                  <p>Nickname</p>
                  <p className="md:w-[50%] text-center">
                    {selectedCustomerData?.nickname}
                  </p>
                </div>
                <div className="flex justify-between md:w-[50%] md:pl-[0.5rem] items-center  h-[100%] ">
                  <p>Name</p>
                  <p className="md:w-[50%] text-center">
                    {selectedCustomerData?.customer_name}
                  </p>
                </div>
              </div>
              <div className="md:flex justify-start items-center border-b md:h-[4rem] mt-2 md:mt-0">
                <div
                  style={{ borderRight: `2rem solid ${coloredTheme}` }}
                  className="flex justify-between md:w-[50%] items-center  md:border-r-[2rem] h-[100%]  ">
                  <p>Max Loan Amount</p>
                  <p className="md:w-[50%] text-center">
                    MYR {selectedCustomerData?.max_loan_amount}
                  </p>
                </div>
                <div className="flex md:pl-[0.5rem] justify-between md:w-[50%] items-center   h-[100%]  "></div>
              </div>

              {customerLoanDetail ? (
                <div className="w-[100%]">
                  <div className="md:flex justify-start items-center border-b md:h-[4rem] mt-2 md:mt-12">
                    <div
                      style={{ borderRight: `2rem solid ${coloredTheme}` }}
                      className="flex justify-between md:w-[50%] items-center  md:border-r-[2rem] h-[100%]  b">
                      <p>Loan Product Code</p>
                      <p className="md:w-[50%] text-center">
                        {selectedLoanProductData?.product_code}
                      </p>
                    </div>
                    <div className="flex md:pl-[0.5rem] justify-between md:w-[50%] items-center   h-[100%]  ">
                      <p>Loan Amount</p>
                      <p className="md:w-[50%] text-center">
                        MYR {selectedLoanProductData?.amount}
                      </p>
                    </div>
                  </div>
                  <div className="md:flex justify-start items-center border-b md:h-[4rem] mt-2 md:mt-0">
                    <div
                      style={{ borderRight: `2rem solid ${coloredTheme}` }}
                      className="flex justify-between md:w-[50%] items-center  md:border-r-[2rem] h-[100%]  ">
                      <p>Payment Frequency</p>
                      <p className="md:w-[50%] text-center">
                        {selectedLoanProductData?.loan_payment_frequency}
                      </p>
                    </div>
                    <div className="flex md:pl-[0.5rem] justify-between md:w-[50%] items-center   h-[100%]  ">
                      <p>Number of Payments</p>
                      <p className="md:w-[50%] text-center">
                        {selectedLoanProductData?.number_of_payments}
                      </p>
                    </div>
                  </div>
                  <div className="md:flex justify-start items-center border-b md:h-[4rem] mt-2 md:mt-0">
                    <div
                      style={{ borderRight: `2rem solid ${coloredTheme}` }}
                      className="flex justify-between md:w-[50%] items-center  md:border-r-[2rem] h-[100%]  ">
                      <p>Standard Payment Amount</p>
                      <p className="md:w-[50%] text-center">
                        {selectedLoanProductData?.collection_amount}
                      </p>
                    </div>
                    <div className="flex md:pl-[0.5rem] justify-between md:w-[50%] items-center   h-[100%]  ">
                      <p>Agent Stamp Commission</p>
                      <p className="md:w-[50%] text-center">
                        {selectedLoanProductData?.stamp_commission}
                      </p>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>

          {!customerLoanDetail ? (
            <div className="w-[100%]">
              {/* Search for loan Product */}
              <div className="bg-white md:text-[0.75rem] lg:text-[1rem]">
                <p
                  style={{ backgroundColor: coloredTheme }}
                  className=" text-white  px-[0.5rem] py-[1rem] mt-6">
                  Search for the Loan Product the Customer will take and then
                  select it .
                </p>
                <div className="md:px-[0.5rem] px-[0.7rem] py-[0.5rem] mt-[1rem] ">
                  <div className="flex justify-start items-center">
                    <label htmlFor="customerNickname" className="w-[30%]">
                      Loan Product Code
                    </label>
                    <input
                      value={productCode}
                      onChange={(e) => setProductCode(e.target.value)}
                      type="text"
                      id="customerNickname"
                      className="border outline-none p-[0.5rem] border-gray-600 flex-1 rounded-lg"
                      placeholder="Enter Loan Product Code"
                    />
                  </div>
                  <div className="flex justify-start items-center mt-[0.8rem]">
                    <p className="w-[30%]">Loan Payment Frequency</p>
                    <FormControl>
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        value={filterFrequency}
                        onChange={(e) => setFilterFrequency(e.target.value)}>
                        <FormControlLabel
                          value="Daily"
                          control={<Radio />}
                          label="Daily"
                        />
                        <FormControlLabel
                          value="Weekly"
                          control={<Radio />}
                          label="Weekly"
                        />
                        <FormControlLabel
                          value="Monthly"
                          control={<Radio />}
                          label="Monthly"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                  <div>
                    <button
                      onClick={() => getLoanProductListApiCall()}
                      style={{ backgroundColor: coloredTheme }}
                      className="flex justify-start items-center space-x-2   px-[1rem] py-[0.5rem] rounded text-white   transition duration-[0.6s] hover:shadow-2xl hover:shadow-black mt-[1rem]">
                      <CiSearch />
                      <span>Search for loan</span>
                    </button>
                  </div>
                </div>
              </div>

              {/* Loan Table */}
              <div className="overflow-scroll  mt-[1rem]">
                <table className="md:w-[100%] xl:w-[100%] w-[180%] ">
                  <thead
                    style={{ backgroundColor: coloredTheme }}
                    className="h-[6vh]  text-white tracking-wider ">
                    <tr>
                      <th className="text-center border-r  border-gray-700 px-[0.2rem]">
                        {" "}
                        Product Code
                      </th>
                      <th className="text-center border-r  border-gray-700 px-[0.2rem]">
                        Amount
                      </th>
                      <th className="text-center border-r  border-gray-700 px-[0.2rem]">
                        Loan Payment Frequency
                      </th>
                      <th className="text-center border-r  border-gray-700 px-[0.2rem]">
                        Number of Payments
                      </th>
                      <th className="text-center  px-[0.2rem]">
                        Collection Amount
                      </th>
                      <th className="text-center  px-[0.2rem]">
                        Stamp Commission
                      </th>
                      <th className="text-start border-b  border-gray-400 px-[0.2rem]"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {loanProductList.length ? (
                      loanProductList.map((x, index) => (
                        <tr
                          className={
                            index % 2 === 0 ? "bg-white " : "bg-sky-100"
                          }>
                          <td className="text-center border-r border-gray-700  px-[0.2rem]">
                            {x.product_code}
                          </td>
                          <td className="text-center border-r border-gray-700  px-[0.2rem]">
                            MYR {x.amount}
                          </td>
                          <td className="text-center border-r border-gray-700 px-[0.2rem]">
                            {x.loan_payment_frequency}
                          </td>
                          <td className="text-center border-r border-gray-700 px-[0.2rem]">
                            {x.number_of_payments}
                          </td>
                          <td className="text-center px-[0.2rem] border-r border-gray-700">
                            MYR {x.collection_amount}
                          </td>
                          <td className="text-center px-[0.2rem]">
                            MYR {x.stamp_commission}
                          </td>
                          <td className="flex justify-center items-center space-x-4 py-[0.5rem]   px-[0.2rem]">
                            <button
                              onClick={() => {
                                setSelectedLoanProductData(x);
                                setCustomerLoanDetail(true);
                              }}
                              style={{ backgroundColor: coloredTheme }}
                              className=" flex justify-center items-center space-x-2  px-[1rem] py-[0.5rem] rounded text-white transition duration-[3s] hover:shadow-2xl hover:shadow-black">
                              <BsCheckLg />
                              <span>Select</span>
                            </button>
                            {/* manager/admin access to close a loan */}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr className="bg-white ">
                        <td className="text-start  px-[0.2rem]">
                          Anup A Doddamani
                        </td>
                        <td className="text-start  px-[0.2rem]">By Anup</td>
                        <td className="text-start px-[0.2rem]">1</td>
                        <td className="text-start px-[0.2rem]">1</td>
                        <td className="text-start px-[0.2rem]">1</td>
                        <td className="flex justify-center items-center space-x-4 py-[0.5rem]   px-[0.2rem]">
                          <button
                            onClick={() => setCustomerLoanDetail(true)}
                            style={{ backgroundColor: coloredTheme }}
                            className=" flex justify-center items-center space-x-2  text-purple-50 px-[1rem] py-[0.5rem] rounded hover:shadow-2xl hover:shadow-black">
                            <BsCheckLg />
                            <span>Select</span>
                          </button>
                          {/* manager/admin access to close a loan */}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <div>
                <button
                  style={{ backgroundColor: coloredTheme }}
                  onClick={() => setShowLoanCustomerDetail(false)}
                  className="flex justify-start items-center space-x-2  px-[1rem] py-[0.5rem] rounded text-white transition duration-[3s]  hover:shadow-2xl hover:shadow-black mt-[1rem]">
                  <TbArrowBackUp />
                  <span>Cancel</span>
                </button>
              </div>
            </div>
          ) : (
            ""
          )}

          {customerLoanDetail ? (
            <div className="bg-white p-[0.8rem] mt-12">
              <div className="flex justify-start items-center ">
                <label htmlFor="cashDate" className="w-[40%]">
                  Date Cash was given to the Customer
                </label>
                <input
                  value={addLoanPayload.cash_disbursed_date}
                  onChange={(e) =>
                    setAddLoanPayload((prevState) => ({
                      ...prevState,
                      cash_disbursed_date: e.target.value,
                    }))
                  }
                  id="cashDate"
                  type="date"
                  placeholder="Select A date when Cash was Generated To Customer's Account"
                  className="border  flex-1 p-[0.5rem] rounded-lg border-gray-600"
                />
              </div>
              <div className="flex justify-start items-center mt-4">
                <label htmlFor="loanStamp" className="w-[40%]">
                  Customer Stamp Duty
                </label>
                <input
                  value={addLoanPayload.customer_stamp_duty}
                  onChange={(e) =>
                    setAddLoanPayload((prevState) => ({
                      ...prevState,
                      customer_stamp_duty: e.target.value,
                    }))
                  }
                  className="border  flex-1 p-[0.5rem] rounded-lg border-gray-600"
                  id="loanStamp"
                  type="number"
                  placeholder="Enter A Customer Stamp"
                />
              </div>
              <div className="flex justify-start items-center mt-4 ">
                <label htmlFor="loanStamp" className="w-[40%]">
                  Future Holidays (deducted at Standard Payment Amount)
                </label>
                <input
                  value={addLoanPayload.future_holidays}
                  onChange={(e) =>
                    setAddLoanPayload((prevState) => ({
                      ...prevState,
                      future_holidays: e.target.value,
                    }))
                  }
                  className="border  flex-1 p-[0.5rem] rounded-lg border-gray-600"
                  id="loanStamp"
                  type="number"
                  placeholder="Enter Future Holidays"
                />
              </div>
              <div className="flex justify-start items-center mt-4">
                <label className="w-[40%]" htmlFor="loanStamp">
                  Advance Payments (deducted at Standard Payment Amount)
                </label>
                <input
                  onChange={(e) => {
                    setAddLoanPayload((prevState) => ({
                      ...prevState,
                      initial_days_deducted: e.target.value,
                    }));
                    setAdvancePayments(e.target.value);
                  }}
                  className="border  flex-1 p-[0.5rem] rounded-lg border-gray-600"
                  id="loanStamp"
                  type="number"
                  placeholder="Enter Advance Paments"
                />
              </div>
              <div className="flex justify-start items-center mt-4">
                <label className="w-[40%]" htmlFor="loanStamp">
                  Amount that should have been paid to the Customer
                </label>
                <p className="  flex-1 p-[0.5rem] ">
                  {addLoanPayload.amount_dispersed < 0
                    ? `-MYR ${
                        addLoanPayload.amount_dispersed -
                        2 * addLoanPayload.amount_dispersed
                      }`
                    : addLoanPayload.amount_dispersed > 0
                    ? `MYR ${addLoanPayload.amount_dispersed}`
                    : ""}
                </p>
              </div>
              {isAmountDispersed ? (
                <div className="flex justify-start items-center mt-4">
                  <p className="w-[40%]">Are The Above Details Correct?</p>
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={confirmDetail}
                      onChange={(e) => setConfirmDetail(e.target.value)}>
                      <FormControlLabel
                        value={true}
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value={false}
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              ) : (
                ""
              )}
              <div className="flex justify-start items-center space-x-4">
                <button
                  style={{ backgroundColor: coloredTheme }}
                  onClick={() => setCustomerLoanDetail(false)}
                  className="flex justify-start items-center space-x-2  px-[1rem] py-[0.5rem] rounded text-white transition duration-[3s] hover:shadow-2xl hover:shadow-black mt-[1rem]">
                  <TbArrowBackUp />
                  <span>Cancel</span>
                </button>
                <button
                  style={{ backgroundColor: coloredTheme }}
                  onClick={() => addLoanHandler()}
                  className={
                    "flex justify-start items-center space-x-2  px-[1rem] py-[0.5rem] rounded text-white transition duration-[3s] hover:shadow-2xl hover:shadow-black mt-[1rem]"
                  }>
                  <FaSave />
                  {loading ? (
                    <span className=" animate-pulse duration-[0.3s] transition tracking-wider">
                      Processing ...
                    </span>
                  ) : (
                    <span>Save Loan</span>
                  )}
                </button>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      )}

      <ToastContainer
        newestOnTop={false}
        rtl={false}
        transition={Flip}
        position="top-right"
        autoClose={2000}
        theme="dark"
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={false}
        draggable={true}
        progress={undefined}
        className="text-center"
      />
    </div>
  );
}

export default LoanDetail;
